export const API_PREFIX = '/api/v1/';
